import { ClientListModel } from './../../models/client/clientListModel';
import { ClientSearchModel } from './../../models/client/clientSearchModel';
import { ClientLocationModel } from './../../models/client/clientLocationModel';
import { IClient, ILocation } from './../../common/appDatabase';
import { ClientModel } from './../../models/client/clientModel';
import AppDatabase from "../../common/appDatabase";

class LocalClientsService {
    db = new AppDatabase();

    getClients = () => {
        let clients = new Array<ClientModel>();

        let result = new Promise((resolve, reject) => {
            this.db.transaction('r', this.db.clients, async () => {
                let dbClients = await this.db.clients.toArray();

                if (dbClients) {
                    for (let i = 0; i < dbClients.length; i++) {
                        let client = this.dbClientToClient(dbClients[i]);
                        clients.push(client);
                    }
                }
            }).then(
                () => {
                    resolve(clients)
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get clients from local db');
            })
        })

        return result;
    }

    getLocations = (clientId: number) => {
        let locations = new Array<ClientLocationModel>();

        let result = new Promise((resolve, reject) => {
            this.db.transaction('r', this.db.locations, async () => {
                await this.db.locations.where({ clientId: clientId }).each(
                    dbLocation => {
                        let location = this.dbLocationToLocation(dbLocation);
                        locations.push(location);
                    }
                );
            }).then(
                () => {
                    resolve(locations)
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get locations from local db');
            })
        })

        return result;
    }

    filterClients = (from: number, numberOfRows: number, searchterm: string) => {
        let searchResult = new ClientListModel();
        searchResult.clients = new Array<ClientSearchModel>();

        let result = new Promise((resolve, reject) => {
            this.db.transaction('r', this.db.clients, this.db.locations, async () => {
                let dbClients = new Array<IClient>();

                let query = this.db.clients.orderBy('name')

                if (searchterm) {
                    query = query.filter((client) => {
                        if (client.name && client.name.toLowerCase().includes(searchterm.toLowerCase())) {
                            return true;
                        }

                        if (client.email && client.email.toLowerCase().includes(searchterm.toLowerCase())) {
                            return true;
                        }

                        if (client.phone && client.phone.toLowerCase().includes(searchterm.toLowerCase())) {
                            return true;
                        }

                        return false;
                    });
                }

                let count = await query.count();
                dbClients = await query.offset(from).limit(numberOfRows).toArray();

                if (dbClients) {
                    for (let i = 0; i < dbClients.length; i++) {
                        let client = this.dbClientToClient(dbClients[i]);
                        let locations = new Array<ClientLocationModel>();

                        await this.db.locations.where({ clientId: dbClients[i].id! }).each(
                            dbLocation => {
                                let location = this.dbLocationToLocation(dbLocation);
                                locations.push(location);
                            }
                        );

                        let result = new ClientSearchModel();
                        result.client = client;
                        result.locations = locations;

                        searchResult.clients.push(result);
                    }
                }

                searchResult.count = count;

            }).then(
                () => {
                    resolve(searchResult);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get result from client search');
            });;
        });

        return result;
    }

    private dbClientToClient = (dbClient: IClient): ClientModel => {
        return {
            id: parseInt(dbClient.id!.toString()),
            name: dbClient.name,
            email: dbClient.email,
            phone: dbClient.phone
        }
    }

    private dbLocationToLocation = (dbLocation: ILocation): ClientLocationModel => {
        return {
            id: parseInt(dbLocation.id!.toString()),
            disctrict: dbLocation.district,
            municipality: dbLocation.municipality,
            town: dbLocation.town,
            address: dbLocation.address,
            latitude: dbLocation.latitude,
            longitude: dbLocation.longitude,
        }
    }
}

export default LocalClientsService;